module.exports = __webpack_public_path__ + "logo.png?24eeffb4a873e9bee8aef443ec5b7e75";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 79
// module chunks = 0